enum QuizTypes {
  Scoring = 'scoring',
  Personality = 'personality',
  Prediction = 'prediction'
};

export default QuizTypes;
